import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Aditivos',
  options: {
    [ProductAdditives.AcesulfamK]: 'Acesulfame K',
    [ProductAdditives.AceSucralose]: 'Ace-Sucralosa',
    [ProductAdditives.Aesculin]: 'Esculina',
    [ProductAdditives.Agar]: 'Agar',
    [ProductAdditives.Anthocyanin]: 'Antocianina',
    [ProductAdditives.Antioxidant]: 'Antioxidante',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Antioxidante: Ácido ascórbico',
    [ProductAdditives.AntioxidantTocopherols]: 'Antioxidante: Tocoferoles',
    [ProductAdditives.Flavor]: 'Aroma',
    [ProductAdditives.Flavors]: 'Aromas',
    [ProductAdditives.AscorbicAcid]: 'Ácido ascórbico',
    [ProductAdditives.Aspartame]: 'Aspartamo',
    [ProductAdditives.OysterSauce]: 'Salsa de ostra',
    [ProductAdditives.BakingAid]: 'Auxiliar de panificación',
    [ProductAdditives.BakingPowder]: 'Levadura en polvo',
    [ProductAdditives.BalsamicVinegar]: 'Vinagre balsámico',
    [ProductAdditives.BalsamicCream]: 'Crema balsámica',
    [ProductAdditives.BasilPesto]: 'Pesto de albahaca',
    [ProductAdditives.BenzoicAcid]: 'Ácido benzoico',
    [ProductAdditives.BetaCarotene]: 'Betacaroteno',
    [ProductAdditives.Betain]: 'Betaína',
    [ProductAdditives.BeetrootRed]: 'Rojo de remolacha',
    [ProductAdditives.Beeswax]: 'Cera de abeja',
    [ProductAdditives.Bitters]: 'Bitters',
    [ProductAdditives.BlueCuracao]: 'Blue Curaçao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Sirope de Blue Curaçao',
    [ProductAdditives.BrandyVinegar]: 'Vinagre de brandy',
    [ProductAdditives.Broth]: 'Caldo',
    [ProductAdditives.Caffeine]: 'Cafeína',
    [ProductAdditives.Calcium]: 'Calcio',
    [ProductAdditives.Caramel]: 'Caramelo',
    [ProductAdditives.CaramelColor]: 'Color caramelo',
    [ProductAdditives.CaramelE150d]: 'Caramelo E150d',
    [ProductAdditives.Carotene]: 'Caroteno',
    [ProductAdditives.CayennePepper]: 'Pimienta de cayena',
    [ProductAdditives.Chili]: 'Chile',
    [ProductAdditives.ChiliDressing]: 'Aderezo de chile',
    [ProductAdditives.ChiliMayonnaise]: 'Mayonesa de chile',
    [ProductAdditives.ChiliOil]: 'Aceite de chile',
    [ProductAdditives.Quinine]: 'Quinina',
    [ProductAdditives.Chlorophyll]: 'Clorofila',
    [ProductAdditives.CitricAcid]: 'Ácido cítrico',
    [ProductAdditives.CitrusAcid]: 'Ácido de cítricos',
    [ProductAdditives.CarbonDioxide]: 'Dióxido de carbono (CO₂)',
    [ProductAdditives.CocktailSauce]: 'Salsa cóctel',
    [ProductAdditives.Curry]: 'Curry',
    [ProductAdditives.CurryPaste]: 'Pasta de curry',
    [ProductAdditives.CurryPowder]: 'Curry en polvo',
    [ProductAdditives.CurryCreamSauce]: 'Salsa crema de curry',
    [ProductAdditives.Fragrance]: 'Fragancia',
  },
};
